<template>
  <div v-if="!tabLoading">
    <div class="grid">
      <div class="grid__cell col5-of-12--medium-up">
        <label>
          Default sort
          <div class="select">
            <select @change="updateDefaultSort($event.target.value)">
              <option>Select an option</option>
              <option
                value="reseller__name"
                :selected="defaults.defaultSort === 'reseller__name'"
                >Name</option
              >
              <option
                value="-rating"
                :selected="defaults.defaultSort === '-rating'"
                >Rating</option
              >
              <option
                value="tier__order"
                :selected="defaults.defaultSort === 'tier__order'"
                >Tier</option
              >
            </select>
          </div>
          <p class="help-text mt-xs">
            This will be the default sort by method for your directory.
          </p>
        </label>
      </div>
    </div>
    <hr class="mb-sm mt-sm" />
    <div class="grid grid--rev">
      <div class="grid__cell col4-of-12--large-up"></div>
      <div class="grid__cell col8-of-12--large-up">
        <p class="fw-bold fs-md mb-sm">Current filters</p>
        <FilterList
          v-for="(filter, i) in allItems"
          :key="i"
          :data="filter"
          @item-change="updateItem"
          @new-item-change="updateNewItem"
          @remove-item="removeItem"
          @remove-new-item="removeNewItem"
          @change-order="changeTheFilterOrder"
          :new="filter.new"
          :last="i === allItems.length - 1"
        />
        <Button
          bType="secondary"
          class="mt-3"
          v-on:button-click="addNewItem(allItems.length)"
        >
          Add new filter
          <!-- <i class="fa fa-plus ml-xs"></i> -->
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import FilterList from '@/components/Dashboard/SettingsFilterList';
import { createNamespacedHelpers } from 'vuex';
import Button from '@/components/DesignSystem/Button';
const { mapGetters, mapActions } = createNamespacedHelpers('settings/filters');

export default {
  components: {
    FilterList,
    Button,
  },
  computed: {
    ...mapGetters(['allItems', 'defaults']),
    tabLoading() {
      return this.$store.getters['tabLoading'];
    },
  },
  methods: {
    ...mapActions([
      'fetchFilters',
      'addNewItem',
      'updateItem',
      'updateNewItem',
      'removeItem',
      'removeNewItem',
      'changeFilterOrder',
      'clearItems',
      'updateDefaultSort',
      'fetchDefaults',
    ]),
    changeTheFilterOrder(payload) {
      this.changeFilterOrder(payload);
      this.$forceUpdate();
    },
  },
  created() {
    this.clearItems();
    // this.fetchFilters();
    // this.fetchDefaults()
  },
};
</script>
